export const ACTIONS = {
	SET_USER_DATA: 'SET_USER_DATA',
	SET_SALES_DROPDOWN_OPTION: 'SET_SALES_DROPDOWN_OPTION',
};